"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListItemStyles = exports.useStyles = void 0;

require("core-js/modules/es.object.define-property.js");

var _core = require("../core");

var _utils = require("../utils");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: _defineProperty({
      minHeight: '3rem',
      paddingLeft: theme.spacing(2),
      '&:hover': {
        backgroundColor: theme.palette.primary.lightest
      }
    }, theme.breakpoints.up('sm'), {
      minHeight: '3rem'
    }),
    selected: {
      '$root&': {
        paddingLeft: theme.spacing(2) - 4,
        borderLeft: "4px solid ".concat(theme.palette.primary.main),
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.altLight,
        '&:hover': {
          backgroundColor: theme.palette.primary.lightest
        }
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('MenuItem')
});
exports.useStyles = useStyles;
var useListItemStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    disabled: {
      backgroundColor: theme.palette.grey['50']
    },
    focusVisible: {
      '&&': {
        backgroundColor: theme.palette.primary.lightest
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('ListItem')
});
exports.useListItemStyles = useListItemStyles;